const INIT = "checkout/INIT";
const TOGGLE_ACCOUNT_CREATION = "checkout/my-account/TOGGLE_ACCOUNT_CREATION";
const SET_CHANGED_OPT_INS = "checkout/my-account/SET_CHANGED_OPT_INS";
const ACCOUNT_CREATE_SUCCESS = "checkout/my-account/ACCOUNT_CREATE_SUCCESS";
const UPDATE_CART_STATE = "checkout/cart/UPDATE_CART_STATE";
const CART_UPDATE_FAILED = "checkout/cart/CART_UPDATE_FAILED";
const SET_DONATION = "checkout/SET_DONATION";
const CLEAR_ERROR = "checkout/error/CLEAR_ERROR";
const init = () => ({
  type: INIT
});
const updateCartState = (payload) => ({
  type: UPDATE_CART_STATE,
  payload
});
const toggleAccountCreation = (payload) => ({
  type: TOGGLE_ACCOUNT_CREATION,
  payload
});
const setChangedOptIns = (payload) => ({
  type: SET_CHANGED_OPT_INS,
  payload
});
const setDonation = (payload) => ({
  type: SET_DONATION,
  payload
});
export {
  ACCOUNT_CREATE_SUCCESS,
  CART_UPDATE_FAILED,
  CLEAR_ERROR,
  INIT,
  SET_CHANGED_OPT_INS,
  SET_DONATION,
  TOGGLE_ACCOUNT_CREATION,
  UPDATE_CART_STATE,
  init,
  setChangedOptIns,
  setDonation,
  toggleAccountCreation,
  updateCartState
};
//# sourceMappingURL=actions.js.map
